const CircleDefaultPropertyPalette = () => {

    return (
        <></>
    )
}


function createDefaultPropertyPalette () {

    return <CircleDefaultPropertyPalette/>
}

export {createDefaultPropertyPalette}
